var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.grp_id === _vm.statement)?[_c('CommonStatementDocument',{attrs:{"grpId":_vm.grp_id}})]:[_c('CommonPreUpload',{attrs:{"grpId":_vm.grp_id}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }